

import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import capitalizeFirstLetter from '../../../../../Comman/UpperCase';
import moment from "moment";
import { data } from 'jquery';


export const exportToXlsxForDetailReport = (data) => {
  // Create a new workbook
  const wb = XLSX.utils.book_new();

  // Iterate through each branch
  data.forEach(branchData => {
    const branch = branchData;

    // Sort order list by order_date
    branch.order_list.sort((a, b) => new Date(a.order_date).getTime() - new Date(b.order_date).getTime());

    // Create a worksheet for the current branch
    const ws = XLSX.utils.aoa_to_sheet([
      ["Order Date", "Order Type", "Table Number", "Gross Total", "Total Discount", "Promo Code", "Unique Code",
        "Gross Total with TAX (Less Discount)", "Food", "Alcohol Drinks", "Soft Drinks",
        "VAT Food", "VAT Alcoholic Drinks", "VAT Soft Drinks", "Total VAT", "Net Total without Tax", "Discount Reason", "Payment Method","Room Number", "Guest Name"],
      ...branch.order_list.map(order => [
        order.order_date, capitalizeFirstLetter(order.order_type), order?.table_number, order.gross_total, order.total_discount, order?.promo_code || "---",
        order?.unique_code || "---", order.gross_total_with_tax, order.food, order.alcoholic_drinks, order.soft_drinks,
        order.vat_food, order.vat_alcohol_drinks, order.vat_soft_drinks, order.total_vat,
        order.net_total_without_tax, order?.additional_discount_reason || "---", order?.payment_method,order?.room_number, order?.guest_name
      ])
    ]);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name);
  });

  // Write the workbook to a file
  XLSX.writeFile(wb, "Order_Details.xlsx");
};

export const exportXlsxSummrayForReport = (jsonData, start_date, end_date, currencyLabel) => {
  const wb = XLSX.utils.book_new();

  const Header1 = [{
    v: `Generated by Gurjinder Singh ${(moment(new Date()).format('DD-MM-YYYY h:mm:ss a'))}. All Figures in ${currencyLabel} except where noted`,
  }];
  const Header2 = [];

  const Header4 = [];
  const Header5 = [`Business report for ${moment(start_date).format('D MMMM YYYY')} ${moment(end_date || new Date()).format('D MMMM YYYY')}`];

  const Header8 = [];
  const Header9 = ['Sales'];
  const secondRowHeader = [
    "Order Type",
    "Gross Total",
    "Total Discount",
    "Gross Total with TAX (Less Discount)",
    "Food Tax",
    "Alcohol Drinks Tax",
    "Soft Drinks Tax",
    "Total Tax",
    "Net Total without Tax"
  ];

  jsonData.forEach(branch => {
    const Header3 = [`${branch?.branch_address} - ${branch?.branch_name}`];
    const Header6 = [`Date of first receipt : ${moment(branch?.first_date).format("DD-MM-YYYY h:mm A") || "No Data"}`];
    const Header7 = [`Date of last receipt : ${moment(branch?.last_date).format("DD-MM-YYYY h:mm A") || "No Data"}`];

    const wsData = [
      Header1, Header2, Header3, Header4, Header5, Header6, Header7, Header8, Header9, secondRowHeader
    ];

    let subtotalRow = null;

    branch.order_list.forEach(order => {
      if (order.order_type === "Total") {
        // If it's a "Total" order type, save it as the subtotal row
        subtotalRow = [
          capitalizeFirstLetter(order.order_type),
          order.order_details.total_gross_total,
          order.order_details.total_total_discount,
          order.order_details.total_gross_total_with_tax,
          order.order_details.total_food_tax,
          order.order_details.total_alcoholic_drinks_tax,
          order.order_details.total_soft_drinks_tax,
          order.order_details.total_total_tax,
          order.order_details.total_net_total_without_tax
        ];
      } else {
        // If it's not a "Total" order type, push the regular order details row
        const rowData = [
          capitalizeFirstLetter(order.order_type),
          order.order_details.gross_total,
          order.order_details.total_discount,
          order.order_details.gross_total_with_tax,
          order.order_details.food_tax,
          order.order_details.alcoholic_drinks_tax,
          order.order_details.soft_drinks_tax,
          order.order_details.total_tax,
          order.order_details.net_total_without_tax
        ];
        wsData.push(rowData);
      }
    });

    // Push the subtotal row after all regular order details
    if (subtotalRow !== null) {
      wsData.push(subtotalRow);
    }

    // Create a worksheet for the current branch
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Add the worksheet to the workbook with branch name as sheet name
    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name);
  });

  XLSX.writeFile(wb, 'Order_Summary.xlsx');
}

export const exportXlsxReservationForReport = (jsonData, start_date, end_date) => {
  const wb = XLSX.utils.book_new();
  console.log("inside ")

  const Header1 = [{
    v: `Table Reservation Report`
    // v: `Generated by Gurjinder Singh ${(moment(new Date()).format('DD-MM-YYYY h:mm:ss a'))}. All Figures in ${currencyLabel} except where noted`,
  }];
  // const Header2 = [];

  // const Header4 = [];
  // const Header5 = [`Business report for ${moment(start_date).format('D MMMM YYYY')} ${moment(end_date || new Date()).format('D MMMM YYYY')}`];

  // const Header8 = [];
  // const Header9 = ['Sales'];
  const secondRowHeader = [
    "Booking ID",
    "Status",
    "Request Type",
    "Reservation Type",
    "Reservation Date",
    "Reservation Time",
    "Booking Date",
    "Customer Details",
    "Table Number"
  ];

  jsonData.forEach(branch => {
    console.log(".....inside loop",branch)
    const Header2 = [`Total Successfully Completed Reservations: ${branch.summaryCounts.find(item => item.status === "Guests Arrived")?.count || 0}`];
    const Header3 = [`Total Guest Non-Arrival Reservations: ${branch.summaryCounts.find(item => item.status === "accepted")?.count || 0}`];
    const Header4 = [`Total Pending Reservations: ${branch.summaryCounts.find(item => item.status === "pending")?.count || 0}`];
    const Header5 = [`Total Cancelled Reservations: ${branch.summaryCounts.find(item => item.status === "cancelled")?.count || 0}`];


    const Header6 = [`Start date: ${moment(start_date).format("DD-MM-YYYY") || "No Data"}`];
    const Header7 = [`End date: ${moment(end_date).format("DD-MM-YYYY") || "No Data"}`];

    const wsData = [
      Header1, Header2, Header3, Header4, Header5, Header6, Header7, secondRowHeader
    ];

    let subtotalRow = null;

    console.log("...................ast2")
    branch.reservations.forEach(reservation => {
      // if (order.order_type === "Total") {
      //   // If it's a "Total" order type, save it as the subtotal row
      //   subtotalRow = [
      //     reservation.booking_id,
      //     reservation.status,
      //     reservation.booking_request_type,
      //     reservation.booking_type,
      //     reservation.bookingDate,
      //     moment(reservation?.booking_date).format("DD-MM-YYYY h:mm A"),
      //     moment(reservation?.reservation_date).format("DD-MM-YYYY h:mm A"),
      //   ];
      // } else {
      //   // If it's not a "Total" order type, push the regular order details row
        const rowData = [
          reservation.booking_id,
          reservation.status,
          reservation.booking_request_type,
          reservation.booking_type,
          moment(reservation?.booking_date).format("DD-MM-YYYY"),
          reservation.booking_time,
          moment(reservation?.reservation_date).format("DD-MM-YYYY"),
          `${reservation.name || "--"}
${reservation.email || "--"}
${reservation.phone_number || "--"}`,
          reservation.table_number || "--"
        ];
        wsData.push(rowData);
      // }
    });

    // Push the subtotal row after all regular order details
    if (subtotalRow !== null) {
      wsData.push(subtotalRow);
    }

    // Create a worksheet for the current branch
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Add the worksheet to the workbook with branch name as sheet name
    XLSX.utils.book_append_sheet(wb, ws, branch.branch_name);
  });
console.log("...................ast")
  XLSX.writeFile(wb, 'Reservations.xlsx');
}

export const exportPDFforDetailReport = (data) => {
  const headers = ["Order Date", "Order Type", "Table Number", "Gross Total", "Total Discount", "Promo Code", "Unique Code",
    "Gross Total with TAX (Less Discount)", "Food", "Alcohol Drinks", "Soft Drinks",
    "VAT Food", "VAT Alcoholic Drinks", "VAT Soft Drinks", "Total VAT", "Net Total without Tax", "Discount Reason", "Payment Method", "Room Number", "Guest Name"];

  // Initialize jspdf
  const doc = new jsPDF({ orientation: "landscape" });

  // Iterate through each branch
  data.forEach((branch, index) => {
    // Sort order list by order_date
    branch.order_list.sort((a, b) => new Date(a.order_date).getTime() - new Date(b.order_date).getTime());

    // Add page for each branch except the first one
    if (index !== 0) {
      doc.addPage();
    }

    // Add branch name as title
    doc.setFontSize(14);
    doc.text(10, 10, `Branch Name: ${branch.branch_name}`);

    // Initialize array to hold data rows for current branch
    const pdfData = [headers];

    // Iterate through each order in the branch
    branch.order_list.forEach(order => {
      // Extract data for each order
      const {
        order_date, order_type, table_number, gross_total, total_discount, promo_code, unique_code,
        gross_total_with_tax, food, alcoholic_drinks, soft_drinks,
        vat_food, vat_alcohol_drinks, vat_soft_drinks, total_vat,
        net_total_without_tax, additional_discount_reason, payment_method, room_number, guest_name,
      } = order;

      // Create a row for the order
      const row = [
        order_date, capitalizeFirstLetter(order_type), table_number, gross_total, total_discount, promo_code || "---",
        unique_code || "---", gross_total_with_tax, food, alcoholic_drinks, soft_drinks,
        vat_food, vat_alcohol_drinks, vat_soft_drinks, total_vat,
        net_total_without_tax, additional_discount_reason || "---", 
        payment_method || "---", room_number || "---", guest_name || "---",
      ];

      // Add the row to the data array
      pdfData.push(row);
    });

    // Convert the data to PDF format
    doc.autoTable({
      head: [headers],
      body: pdfData.slice(1), // Exclude headers from body
      margin: { top: 20 }, // Add margin from top
      startY: 20, // Start Y position
      theme: "grid", // Add grid theme (borders)
      styles: {
        fontSize: 7, // Font size for header
      },
      headerStyles: {
        fillColor: "darkgray",
        textColor: "#000",
        halign: "center",
      },
      bodyStyles: {
        fontSize: 6,
        textColor: [0, 0, 0], // Font size for body
      },
    });
  });

  // Save the PDF
  const todayDate = moment().format("DD_MM_YYYY");
  const fileName = `Order_Details_${todayDate}.pdf`;

  // Save the PDF
  doc.save(fileName);
};

export const exportPDFforSummrayReport = (data, start_date, end_date, currencyLabel) => {

  const Mainheaders = [
    {
      content: 'Sale',
      styles: {
        halign: 'center',
        fontStyle: 'bold',
        lineWidth: 0.2, // Border thickness
        lineColor: [0, 0, 0], // Border color (black in this example)
        // lineRadius: 1, 
        fontSize: 12,
        fillColor: "darkgray",
        textColor: "#000",// Border radius
      },
      colSpan: 9
    }
  ];

  const headers = [
    "Order Type", "Gross Total", "Total Discount", "Gross Total with TAX (Less Discount)",
    "Food Tax", "Alcohol Drinks Tax", "Soft Drinks Tax", "Total Tax", "Net Total without Tax", "Discount Reason"
  ];
  const headerStyles = {
    halign: "center",
    fontStyle: 'bold',
    fillColor: "darkgray",
    textColor: "#000", // White background
    // lineWidth: 0.2,
    fontSize: 8,
    // lineColor: [0, 0, 0], // Border color (black in this example)
  };

  const headersWithStyles = headers.map(header => ({ content: header, styles: headerStyles }));


  const doc = new jsPDF({ orientation: "landscape" });

  data.forEach((branch, index) => {
    branch.order_list.sort((a, b) => new Date(a.order_date).getTime() - new Date(b.order_date).getTime());

    if (index !== 0) {
      doc.addPage();
    }

    doc.setFontSize(11);

    doc.text(10, 10, `Generated by Gurjinder Singh ${moment(new Date()).format('DD-MM-YYYY h:mm:ss a')}. All Figures in ${currencyLabel} except where noted`);

    doc.setFontSize(11);
    doc.text(10, 20, `${branch?.branch_address} - ${branch?.branch_name}`);

    doc.setFontSize(10);
    doc.text(10, 30, `Business report for ${moment(start_date).format('D MMMM YYYY')} ${moment(end_date || new Date()).format('D MMMM YYYY')}`);
    if (branch?.first_date) {
      doc.text(10, 35, `Date of first receipt: ${moment(branch?.first_date).format("DD-MM-YYYY h:mm A") || "---"}`);
      doc.text(10, 40, `Date of last receipt: ${moment(branch?.last_date).format("DD-MM-YYYY h:mm A") || "---"}`);
    }
    // Add branch name as title
    doc.setFontSize(14);
    doc.text(10, branch?.first_date ? 50 : 40, `Branch Name: ${branch.branch_name}`);

    // Initialize array to hold data rows for current branch
    const pdfData = [];

    branch.order_list.forEach(order => {
      // Capitalize the order type
      const capitalizedOrderType = capitalizeFirstLetter(order.order_type);

      // Extract data based on order_type
      let row;
      if (order.order_type === "Total") {
        const {
          total_gross_total,
          total_total_discount,
          total_gross_total_with_tax,
          total_food_tax,
          total_alcoholic_drinks_tax,
          total_soft_drinks_tax,
          total_total_tax,
          total_net_total_without_tax,

        } = order.order_details;
        row = [
          capitalizedOrderType,
          total_gross_total,
          total_total_discount,
          total_gross_total_with_tax,
          total_food_tax,
          total_alcoholic_drinks_tax,
          total_soft_drinks_tax,
          total_total_tax,
          total_net_total_without_tax
        ];
      } else {
        const {
          gross_total,
          total_discount,
          gross_total_with_tax,
          food_tax,
          alcoholic_drinks_tax,
          soft_drinks_tax,
          total_tax,
          net_total_without_tax
        } = order.order_details;
        row = [
          capitalizedOrderType,
          gross_total,
          total_discount,
          gross_total_with_tax,
          food_tax,
          alcoholic_drinks_tax,
          soft_drinks_tax,
          total_tax,
          net_total_without_tax
        ];
      }

      pdfData.push(row);
    });

    // Convert the data to PDF format
    doc.autoTable({
      head: [headersWithStyles], // Pass headers here
      body: pdfData, // Pass pdfData directly
      margin: { top: branch?.first_date ? 60 : 50 }, // Add margin from top
      startY: branch?.first_date ? 60 : 50, // Start Y position
      theme: "grid", // Add grid theme (borders)
      styles: {
        fontSize: 7, // Font size for header
      },
      // headerStyles: {
      //   fillColor: "darkgray",
      //   textColor: "#000",
      //   halign: "center",
      // },
      bodyStyles: {
        fontSize: 8,
        textColor: [0, 0, 0], // Font size for body
      },
    });
  });

  // Save the PDF
  const todayDate = moment().format("DD_MM_YYYY");
  const fileName = `Order_Summary_${todayDate}.pdf`;

  // Save the PDF
  doc.save(fileName);
}

export const exportPDFforReservationReport = (data, start_date, end_date) => {

  const headers = [
    "Booking ID",
    "Status",
    "Request Type",
    "Reservation Type",
    "Reservation Date",
    "Reservation Time",
    "Booking Date",
    "Customer Details",
    "Table Number"
  ];
  const headerStyles = {
    halign: "center",
    fontStyle: 'bold',
    fillColor: "darkgray",
    textColor: "#000", // White background
    // lineWidth: 0.2,
    fontSize: 8,
    // lineColor: [0, 0, 0], // Border color (black in this example)
  };

  const headersWithStyles = headers.map(header => ({ content: header, styles: headerStyles }));


  const doc = new jsPDF({ orientation: "landscape" });

  data.forEach((branch, index) => {
    // branch.order_list.sort((a, b) => new Date(a.order_date).getTime() - new Date(b.order_date).getTime());

    if (index !== 0) {
      doc.addPage();
    }

    doc.setFontSize(11);

    doc.setFontSize(14);
    doc.text(10, branch?.first_date ? 50 : 22, `Table Reservation Reports for ${branch.branch_name}`);

    // doc.text(10, 10, `Table Reservation Reports`);

    // doc.setFontSize(11);
    // doc.text(10, 20, `${branch?.branch_address} - ${branch?.branch_name}`);

    doc.setFontSize(10);
    doc.text(10, 30, `Total Successfully Completed Reservations: ${branch.summaryCounts.find(item => item.status === "Guests Arrived")?.count || 0}`);
    doc.setFontSize(10);
    doc.text(10, 38, `Total Guest Non-Arrival Reservations: ${branch.summaryCounts.find(item => item.status === "accepted")?.count || 0}`);
    doc.setFontSize(10);
    doc.text(10, 46, `Total Pending Reservations: ${branch.summaryCounts.find(item => item.status === "pending")?.count || 0}`);
    doc.setFontSize(10);
    doc.text(10, 54, `Total Cancelled Reservations: ${branch.summaryCounts.find(item => item.status === "cancelled")?.count || 0}`);
    
    doc.setFontSize(10);
    doc.text(10, 62, `Start date: ${moment(start_date).format("DD-MM-YYYY h:mm A") || "No Data"}`);
    doc.setFontSize(10);
    doc.text(10, 70, `End date: ${moment(end_date).format("DD-MM-YYYY h:mm A") || "No Data"}`);
    
    // Add branch name as title


    // Initialize array to hold data rows for current branch
    const pdfData = [];

    branch.reservations.forEach(reservation => {

      let row;

        row = [
          reservation.booking_id,
          reservation.status,
          reservation.booking_request_type,
          reservation.booking_type,
          moment(reservation?.booking_date).format("DD-MM-YYYY"),
          reservation?.booking_time,
          moment(reservation?.reservation_date).format("DD-MM-YYYY"),
          `${reservation.name || "--"}
${reservation.email || "--"}
${reservation.phone_number || "--"}`,
           reservation.table_number || "--"
        ];
      // }

      pdfData.push(row);
    });

    // Convert the data to PDF format
    doc.autoTable({
      head: [headersWithStyles], // Pass headers here
      body: pdfData, // Pass pdfData directly
      margin: { top: 80 }, // Add margin from top
      startY: 80, // Start Y position
      theme: "grid", // Add grid theme (borders)
      styles: {
        fontSize: 7, // Font size for header
      },
      // headerStyles: {
      //   fillColor: "darkgray",
      //   textColor: "#000",
      //   halign: "center",
      // },
      bodyStyles: {
        fontSize: 8,
        textColor: [0, 0, 0], // Font size for body
      },
    });
  });

  // Save the PDF
  const todayDate = moment().format("DD_MM_YYYY");
  const fileName = `Table_Reservation_report.pdf`;

  // Save the PDF
  doc.save(fileName);
}


const headers = [
  "Date",
  "Reference",
  "Company",
  "Dining Location",
  "Cooking Location",
  "Meal",
  "Tour Manager",
  "Tour Manager Number",
  "Total Pax",
  "Veg",
  "Non Veg",
  "Jain",
];

// Helper function to extract tour data
const extractTourData = (tourList) => {
  return tourList.map(({ tour_date, reference, companyinfo, dinning_location, cooking_location, meal_name, tour_manager, tour_manager_no, total_pax, veg, non_veg, jain }) => [
    moment(tour_date).format("DD/MM/YYYY"),
    reference,
    companyinfo?.company_name || "",
    dinning_location,
    cooking_location,
    meal_name,
    tour_manager,
    tour_manager_no,
    total_pax,
    veg,
    non_veg,
    jain,
  ]);
};

// Helper function for downloading files
const downloadFile = (blob, extension) => {
  const fileName = `tour-group-list-${moment().format("DD-MM-YYYY")}.${extension}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

// Export CSV
export const downloadCSVTourGroup = (tourList) => {
  const csvData = [headers, ...extractTourData(tourList)];
  const csvContent = csvData.map((row) => row.join(",")).join("\n");
  const blob = new Blob([csvContent], { type: "text/csv" });
  downloadFile(blob, "csv");
};

// Export PDF
export const downloadPDFTourGroup = (tourList) => {
  const doc = new jsPDF({ orientation: "landscape" });

  doc.autoTable({
    head: [headers],
    body: extractTourData(tourList),
    margin: { top: 5 },
    styles: { fontSize: 10 },
    headerStyles: { fillColor: "darkgray", textColor: "#000", halign: "center" },
    bodyStyles: { textColor: [0, 0, 0] },
    theme: "grid",
    startY: 5,
  });

  const blob = doc.output("blob");
  downloadFile(blob, "pdf");
};

